import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const currentEnvFSId = {
  FileClaim: publicRuntimeConfig.JFCFNOLFormId,
  GetQuote: publicRuntimeConfig.JFCQuotingFormId,
  BuyQuote: publicRuntimeConfig.JFCBuyQuoteFormId,
  MTAPolicy: publicRuntimeConfig.JFCMTAPolicyFormId,
};

//--------------------------------------------------------------------------------------------
// This data should be coming from strapi CMS post integration
// To be removed
export const JOURNEYS_MOCK = [
  {
    page: '/',
    formID: currentEnvFSId.FileClaim,
    formDefaults: {
      productType: 'house',
    },
    slug: 'file-claim',
    title: null,
    type: 'file-claim',
    image: null,
    stage: 'production',
  },
  {
    page: '/',
    formID: currentEnvFSId.GetQuote,
    formDefaults: {
      quoteType: 'fresh',
    },
    slug: 'get-quote',
    title: null,
    type: 'get-quote',
    image: null,
    stage: 'production',
  },
  {
    page: '/',
    formID: currentEnvFSId.BuyQuote,
    formDefaults: {
      quoteType: 'fresh',
    },
    slug: 'buy-quote',
    title: null,
    type: 'buy-quote',
    image: null,
    stage: 'production',
  },
  {
    page: '/',
    formID: currentEnvFSId.MTAPolicy,
    formDefaults: {
      quoteType: 'fresh',
    },
    slug: 'mta-policy',
    title: null,
    type: 'mta-policy',
    image: null,
    stage: 'production',
  },
];
//--------------------------------------------------------------------------------------------

export const JOURNEY_NAMES = {
  FileClaim: 'file-claim',
};

export const FORM_HOST = publicRuntimeConfig.digitalJourneyServiceUrl;

export const getCompanyIdByEnv = (): string => {
  return publicRuntimeConfig.JFCCompanyId;
};

export const JOURNEY_TYPES = {
  FileClaim: 'file-claim',
};

export type FnolJourneys = {
  [key: string]: string;
};
export const FNOLJOURNEYS: FnolJourneys = {
  HUS: 'house',
  BIL: 'car',
  INNBO: 'content',
  REISE: 'travel',
  HUND: 'dogCat'
};

export const COMPANY = getCompanyIdByEnv();
